import api from '../services/api';

/**
 * Checks if a non-archived user with the given username exists within a specific schema.
 * Used before attempting to log in a user.
 * @param idToken string
 * @param schema string
 * @param username string
 * @returns A Promise that resolves to `true` if the user exists and is not archived,
 *          `false` otherwise. Returns `false` for API errors or if no user is found.
 */
export const checkUserExists = async (idToken: string, schema: string, username: string): Promise<boolean> => {
  try {
    const trimmedUsername = username.trim();

    const params = new URLSearchParams();
    params.append('filter', `archived:eq:false`);
    params.append('filter', `userId:eq:${trimmedUsername}`);

    const resp = await api.get(`/users?${params.toString()}`, {
      headers: {
        authorization: `Bearer ${idToken}`,
        'myosh-schema': schema,
      },
    });

    const users = resp.data?.items || [];
    if (users.length > 0) {
      return true;
    }

    return false;
  } catch (error) {
    console.error('Error checking user:', error);
    return false;
  }
};
